import PropTypes from "prop-types"

import Image from "components/ui/image"
import { cn } from "styles/utils"

export const StaticSectionTitle = ({ className, ...props }) => (
  <h2
    className={cn(
      "text-20 tablet:text-left my-20 text-center font-normal text-black",
      className
    )}
    {...props}
  />
)

StaticSectionTitle.propTypes = {
  className: PropTypes.string,
}

export const Section = ({ className, ...props }) => (
  <div
    className={cn("tablet:pb-48 tablet:pt-48 bg-white pt-32", className)}
    {...props}
  />
)

Section.propTypes = {
  className: PropTypes.string,
}

export const SectionTitle = ({ className, ...props }) => (
  <h2
    className={cn(
      "text-20 tablet:text-24 leading-28 text-center font-medium uppercase",
      className
    )}
    {...props}
  />
)

SectionTitle.propTypes = {
  className: PropTypes.string,
}

export const Text = ({ className, ...props }) => (
  <p
    className={cn("text-16 leading-22 font-light tracking-tight", className)}
    {...props}
  />
)

Text.propTypes = {
  className: PropTypes.string,
}

export const ProductImage = ({ blur = false, className = "", ...props }) => (
  <Image
    className={cn(
      "tablet:max-w-(--tablet-max-width) desktop:max-w-(--desktop-max-width) mx-auto block h-auto w-full transition-opacity duration-300 ease-in-out",
      blur ? "opacity-0" : "opacity-100",
      className
    )}
    style={{
      "--desktop-max-width": "500px",
      "--tablet-max-width": "325px",
    }}
    {...props}
  />
)

ProductImage.propTypes = {
  blur: PropTypes.bool,
  className: PropTypes.string,
}

export const Footnote = (props) => (
  <div
    className="my-10 bg-[rgba(37,104,178,0.05)] py-8 text-center"
    {...props}
  />
)

export const FootnoteText = (props) => (
  <p
    className="text-12 leading-14 max-w-240 mx-auto font-bold tracking-tight"
    {...props}
  />
)
